export default {
  'error.title': '系統發生問題',
  'error.description':
    '請嘗試重新整理畫面或重新開啟頁面。<br />若問題仍未解決，請洽詢現場門市人員協助。',
  'error.refresh': '重新整理',
} as Record<string, string>;
